import React from 'react'
import { Type } from 'shared/ui'

export type IBroadcastType = 'sms' | 'ringless' | 'rcs'

type IBroadcastTypeProps = { type: IBroadcastType }

export const BroadcastType = ({ type }: IBroadcastTypeProps) => {
  return <Type type={type} />
}
